module.exports = __webpack_public_path__ + "static/media/eye-on.0092032f.svg";